import { PageMenuItem as PageMenuItemType } from "../../header-menu/HeaderMenuTypes";
import BaseMenuItem from "./BaseMenuItem";

interface PageMenuItemProps {
  item: PageMenuItemType;
  itemIndex: number;
}

export default function PageMenuItem({
  item: { pages, ...baseMenuItem },
  itemIndex,
}: PageMenuItemProps) {
  return (
    <BaseMenuItem
      {...baseMenuItem}
      itemIndex={itemIndex}
      subMenuContent={
        <div className="xflex xgap-64 xjustify-center xw-full xcursor-pointer">
          {pages.map(({ title, url }, index) => (
            <div
              className="xflex xflex-col xgap-4 xitems-center"
              key={index}
              onClick={() => {
                window.location.href = url;
              }}
            >
              <div className="xsize-80 xbg-pink-600">h</div>
              <h3>{title}</h3>
            </div>
          ))}
        </div>
      }
    />
  );
}
